import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "border rounded-lg template-image p-4 me-2 mt-2",
  height: "400px"
}
const _hoisted_2 = { height: "200px" }
const _hoisted_3 = { class: "fz-5" }
const _hoisted_4 = { class: "" }

import { onMounted, ref } from "vue";
import ImageElementButton from "../ui/ImageElementButton.vue";
import CardThumbnail from "../ui/CardThumbnail.vue";
import SoundButton from "../ui/SoundButton.vue";
import VideoButton from "../ui/VideoButton.vue";
import ModelGltfButton from "../ui/ModelGltfButton.vue";
import ModelVrmButton from "../ui/ModelVrmButton.vue";
import ModelPlaneDetectArButton from "../ui/ModelPlaneDetectArButton.vue";
import { getType, FileType, is_vrm } from "../../../utils/UserFile";
import ImageSkyButton from "../ui/ImageSkyButton.vue";

interface Prop {
  filePath: string;
  thumbnailPath: string;
  index: number;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FileCardSectionWithoutDelete',
  props: {
    filePath: null,
    thumbnailPath: null,
    index: { default: 0 },
    name: { default: "" }
  },
  setup(__props: any) {

const props = __props as { filePath: string, thumbnailPath: string, index: number, name: string };



const isVrmModel = ref(is_vrm(props.filePath));
const type = ref<FileType>(getType(props.filePath));
const name = ref(props.name ? props.name : props.filePath.split("/").reverse()[0]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CardThumbnail, {
      "asset-path": __props.filePath,
      thumbnail: __props.thumbnailPath,
      type: type.value
    }, null, 8, ["asset-path", "thumbnail", "type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.index + 1) + ". " + _toDisplayString(name.value), 1),
      _createElementVNode("span", _hoisted_4, [
        (type.value === 'image')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(ImageElementButton, {
                "asset-path": __props.filePath,
                class: "w-100 my-1"
              }, null, 8, ["asset-path"]),
              _createVNode(ImageSkyButton, {
                "asset-path": __props.filePath,
                class: "w-100 my-1"
              }, null, 8, ["asset-path"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(VideoButton, {
          type: type.value,
          "asset-path": __props.filePath,
          class: "w-100 my-1"
        }, null, 8, ["type", "asset-path"]),
        _createVNode(SoundButton, {
          type: type.value,
          "asset-path": __props.filePath,
          class: "w-100 my-1"
        }, null, 8, ["type", "asset-path"]),
        (type.value === 'model')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(ModelGltfButton, {
                "is-vrm": isVrmModel.value,
                "asset-path": __props.filePath,
                class: "w-100 my-1"
              }, null, 8, ["is-vrm", "asset-path"]),
              _createVNode(ModelVrmButton, {
                "is-vrm": isVrmModel.value,
                "asset-path": __props.filePath,
                class: "w-100 my-1"
              }, null, 8, ["is-vrm", "asset-path"]),
              _createVNode(ModelPlaneDetectArButton, {
                "is-vrm": isVrmModel.value,
                "asset-path": __props.filePath,
                class: "w-100 my-1"
              }, null, 8, ["is-vrm", "asset-path"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})